if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
        
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        if(typeof subscribe != 'undefined'){
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
              this.resetRecipientForm();
            }
          });
  
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          });
  
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
            if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
              this.displayErrorMessage(event.message, event.errors);
            }
          });
        }
      }

      disconnectedCallback() {
        if(typeof subscribe != 'undefined'){
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }
  
          if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
          }
  
          if (this.cartErrorUnsubscriber) {
            this.cartErrorUnsubscriber();
          }
        }
      }

      onChange() {
        var recipient_attributes = [];
        
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
          console.log("yes");
          var allvalue = []
          var emailvalue = $('.recipient-fields__field').find('[name="properties[Recipient email]"]').val();
          var dateValue = $('.recipient-fields__field').find('[name="properties[Send on]"]').val();
          var nameValue = $('.recipient-fields__field').find('[name="properties[Recipient name]"]').val();
          var messageValue = $('.recipient-fields__field').find('[name="properties[Message]"]').val();

          console.log("emailvalue",emailvalue);
          console.log("dateValue",dateValue);
          
          $('.date_error').addClass('hide');
          $('.email_error').addClass('hide');

          function validateEmail(emailvalue) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(emailvalue);
          }
        
           if (emailvalue != '') {
            const emailError = $('#emailError');
            if (validateEmail(emailvalue)) {
              emailError.removeClass('button_disabled');
              emailError.text('');
            } else {
              emailError.text('Invalid email address');
              emailError.addClass('button_disabled');
            }
           }
         
          if (emailvalue != '' && dateValue != '') {
            if (validateEmail(emailvalue)) {
              $('.gift-atc-fix').find("button").removeClass('button_disabled');
            }else{
              $('.gift-atc-fix').find("button").addClass('button_disabled');
            } 
          }else{
            $('.gift-atc-fix').find("button").addClass('button_disabled');
          }

             
          if (emailvalue != '' || nameValue != '' || dateValue != '' || messageValue != '') {
            if (emailvalue != ''){
              recipient_attributes[0] = {"attributeName": "Recipient email","values": emailvalue};
            }
            if (nameValue != ''){
              recipient_attributes[1] = {"attributeName": "Recipient name","values": nameValue};
             }
           if (dateValue != ''){
              recipient_attributes[2] = {"attributeName": "Send on","values": dateValue};
           }
           if (messageValue != ''){
            recipient_attributes[3] = {"attributeName": "Message","values": messageValue};
           }
          }
          $('[name="properties[_recipient_attributes]"]').val(JSON.stringify(recipient_attributes));
          console.log('recipient_attributes',recipient_attributes);
          
        } else {
          $('[name="properties[_recipient_attributes]"]').val('');
          $('.gift-atc-fix').find("button").removeClass('button_disabled');
          $('.recipient-fields').find(".custoM_date_format").text('Choose Send Date');
          
          $('.date_error').addClass('hide');
          $('.email_error').addClass('hide');
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
  

    if($('.template-giftcard').length > 0){
       var pdpid = getUrlParameter('itemid');
       var cpid = getUrlParameter('cpid');
        console.log("pdpid",pdpid);
       if($('body').hasClass('temp_webview')){ 
        var webitem_id = getUrlParameter('web_itemid');
          if(webitem_id){
             var web_id = atob(getUrlParameter('web_itemid'));
            var ordeId = atob(getUrlParameter('ck'));
          }
      
        console.log('web_id',web_id);
        console.log('ordeId',ordeId);
        }
       if(pdpid){
         
         var pdpid = parseInt(pdpid) - 1;
         jQuery.getJSON('/cart.js', function(cart) {
           console.log("getAttr",cart);
           var getGiftDetials = cart.items[pdpid]['properties']['__shopify_send_gift_card_to_recipient'];
           var getRecipientEmail= cart.items[pdpid]['properties']['Recipient email'];
           var getRecipientName= cart.items[pdpid]['properties']['Recipient name'];
           var getRecipientSendOn= cart.items[pdpid]['properties']['Send on'];
           var getRecipientCustomMessage= cart.items[pdpid]['properties']['Message'];
           var second_date = moment(getRecipientSendOn).format('DD-MM-YYYY'); 

           console.log('getRecipientEmail',getRecipientEmail);
           console.log('getRecipientSendOn',getRecipientSendOn);
           if( $('#Recipient-checkbox-gift-product-template').is(':checked') ){
           
          if (getGiftDetials == 'on') {
            $('.recipient-form [name="properties[__shopify_send_gift_card_to_recipient]"]').prop('checked',true);
            $('.recipient-form [name="properties[Recipient email]"]').val(getRecipientEmail).removeAttr("disabled");
            $('.recipient-form [name="properties[Recipient name]"]').val(getRecipientName).removeAttr("disabled");
            $('.recipient-form [name="properties[Send on]"]').val(getRecipientSendOn).removeAttr("disabled");
            $('.recipient-form [name="properties[Message]"]').val(getRecipientCustomMessage).removeAttr("disabled");
            $(".recipient-fields .custoM_date_format").text(second_date);
          }
           
           if (getRecipientEmail != '' && getRecipientSendOn != '' && typeof getRecipientEmail != "undefined" && typeof getRecipientSendOn != "undefined") {
              $('.gift-atc-fix').find("button").removeClass('button_disabled');
               $('.email_error').addClass('hide');
               $('.date_error').addClass('hide');
            }else{
              $('.gift-atc-fix').find("button").addClass('button_disabled');
              // $('.email_error').removeClass('hide');
              // $('.date_error').removeClass('hide');
            } 
         }
           $('#Recipient-checkbox-gift-product-template').change(function() {
            if(this.checked) {

           if (getGiftDetials == 'on') {
            $('.recipient-form [name="properties[__shopify_send_gift_card_to_recipient]"]').prop('checked',true);
            $('.recipient-form [name="properties[Recipient email]"]').val(getRecipientEmail).removeAttr("disabled");
            $('.recipient-form [name="properties[Recipient name]"]').val(getRecipientName).removeAttr("disabled");
            $('.recipient-form [name="properties[Send on]"]').val(getRecipientSendOn).removeAttr("disabled");
            $('.recipient-form [name="properties[Message]"]').val(getRecipientCustomMessage).removeAttr("disabled");
            $(".recipient-fields .custoM_date_format").text(second_date);
          }
           
         if (getRecipientEmail != '' && getRecipientSendOn != '' && typeof getRecipientEmail != "undefined" && typeof getRecipientSendOn != "undefined") {
            $('.gift-atc-fix').find("button").removeClass('button_disabled');
             $('.email_error').addClass('hide');
             $('.date_error').addClass('hide');
          }else{
            $('.gift-atc-fix').find("button").addClass('button_disabled');
            // $('.email_error').removeClass('hide');
            // $('.date_error').removeClass('hide');
          } 
            }
           });
          
         });  
       }

    }

$(".gift-atc-fix").click(function(){
  var emailvalue = $('.recipient-fields__field').find('[name="properties[Recipient email]"]').val();
  var dateValue = $('.recipient-fields__field').find('[name="properties[Send on]"]').val();
   if (emailvalue != '') {
    $('.email_error').addClass('hide');
  }else{
  $('.email_error').removeClass('hide');
  }
  if (dateValue != '') {
    $('.date_error').addClass('hide');
  }else{
  $('.date_error').removeClass('hide');
  }
});